export default __webpack_public_path__ + "static/media/record.2e0dfa4e.png";